<router-outlet></router-outlet>

@if (environmentLabel) {
  <div
    class="environment-banner"
    [ngClass]="{
      development: environmentLabel === 'desarrollo',
      testing: environmentLabel === 'testing',
    }"
  >
    Usted esta trabajando sobre {{ environmentLabel }}
  </div>
}
